import { BreakpointCell } from './BreakpointCell';
import { NewDefaultCell } from '@dealstack/frontend/app/pages/Valuations/components/table/cells/NewDefaultCell';

interface Props {
	value: string | number | null;
	tanstackRow: unknown;
	columnIndex?: number;
}

export const BreakpointCellWrapper = ({ value, tanstackRow, columnIndex }: Props) => {
	const row = tanstackRow as {
		original: { metadata?: { overrideField?: string; overrideId?: string } };
	};
	const hasOverride = !!row.original.metadata?.overrideField;

	if (hasOverride) {
		return <BreakpointCell value={value as string} />;
	}

	return (
		<NewDefaultCell
			value={value}
			alignEnd={true}
			alignment="end"
			disableBorders={true}
			columnIndex={columnIndex}
		/>
	);
};
